import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="document-type-form"
//
// Keeps the "Update Type" CTA disabled until the operator has actually picked a different
// document type than the one on the document. The select and the CTA can live in different
// parts of a drawer (body vs footer), so this sits on the drawer wrapper and re-syncs when a
// polled turbo-frame swaps the select in.
export default class extends Controller {
  static targets = ["select", "submit"]

  connect() {
    this.sync()
  }

  // The select lives in a turbo-frame that polls itself from "classifying" into the finished
  // form, so it can appear (and be replaced) long after the controller connected.
  selectTargetConnected() {
    this.sync()
  }

  submitTargetConnected() {
    this.sync()
  }

  sync() {
    if (!this.hasSubmitTarget) return

    if (!this.hasSelectTarget) {
      this.submitTarget.disabled = true
      return
    }

    const value = this.selectTarget.value || ""
    const current = this.selectTarget.dataset.currentDocumentType || ""
    this.submitTarget.disabled = value === "" || value === current
  }
}
